export const translationNavigation_da_part2 = {
  pageSiteTitleHeading: "Sidespecifikke sidetitler",
  pageSiteTitleHelp: "Hjælp til sidespecifikke sidetitler",
  pageSiteTitleDescription:
    "Skift titlen i chatvinduets øverste bjælke på udvalgte sider. Andre sider bruger standard-sidetitlen ovenfor.",
  pageSiteTitleText: "Sidetitel for disse sider",
  pageSiteTitleNoDefault: "Ingen standard-sidetitel angivet",
  pageTitleHeading: "Sidespecifikke chattitler",
  pageTitleHelp: "Hjælp til sidespecifikke chattitler",
  pageTitleImmediate: "Træder i kraft med det samme",
  pageTitleSharedRule:
    "Denne regel styrer også en anden titel eller launcher-billeder. Ændrer du URL eller prioritet, påvirkes de; Fjern titel bevarer dem.",
  pageTitleDescription:
    "Skift overskriften inde i chatten på bestemte sider. Andre sider bruger standardoverskriften ovenfor.",
  pageTitleMatching:
    "En sti som /delivery matcher alle URL'er, der indeholder teksten (der skelnes mellem store og små bogstaver). Brug hele URL'en med jokertegn, f.eks. https://example.com/products/*.",
  pageTitleSaveHelp:
    "Tilføj titel og Gem titel træder i kraft med det samme. Reglerne kræver ikke Udgiv.",
  pageTitleEmpty: "Ingen sidespecifikke titler endnu. Standardtitlen bruges overalt.",
  pageTitleAddHeading: "Tilføj en sidespecifik titel",
  pageTitleUrl: "Side-URL eller mønster",
  pageTitleText: "Chattitel på disse sider",
  pageTitleExample: "Hjælp til levering",
  pageTitlePriority: "Prioritering af regler",
  pageTitlePriorityHelp:
    "Den første matchende sideregel bruges. Lavere tal afprøves først; ved samme tal bruges den ældste regel. URL og prioritet gælder for alle titler og billeder med denne regel.",
  pageTitleOrder: "Prioritet (laveste først)",
  pageTitleSave: "Gem titel",
  pageTitleAdd: "Tilføj titel",
  pageTitleRemove: "Fjern titel",
  pageTitleSaved: "Gemt",
  pageTitleSaving: "Gemmer…",
  pageTitleTest: "Kontrollér en side-URL",
  pageTitleTestHelp:
    "Indtast en hel side-URL for at se, hvilken gemt titel der bruges. Gem dine ændringer først.",
  pageTitleMatched: "Denne side bruger en tilpasset titel:",
  pageTitleDefault: "Denne side bruger standardtitlen:",
  pageTitleNoDefault: "Ingen standardtitel angivet",
  pageTitleMatchingRule: "Matchende sideregel",
  showLivechatAvailability: "Vis livechattens tilgængelighed ved chattens titel",
  showLivechatAvailabilityDescription:
    "Vis en grøn prik, når livechat er tilgængelig, ud fra chatbottens livechatstatus og åbningstider. Der vises intet, når livechat er offline.",
  widgetLeftSide: "Vis widgetten til venstre",
  widgetLeftSideDescription:
    "Placer launcher og chatvindue til venstre med popupbeskeder mod højre. Gælder launcheren på både computer og mobil.",
  launcherStyle: "Launcherens udseende",
  launcherStyleIcon: "Rundt ikon",
  launcherStyleBar: "Launcher-bjælke",
  launcherStyleDescription:
    "Launcher-bjælken vises i 5 sekunder på den første side af et besøg, viser popupbeskeder i sit tekstfelt og er minimeret resten af tiden. Den åbner igen, når man peger på den, uden at chatten åbner.",
  launcherEdgeDistance: "Launcherens afstand fra kanten",
  mobileLauncherEdgeDistance: "Mobillauncherens afstand fra kanten",
  mobileLauncherLeftEdge: "Kompakt launcher i venstre kant",
  mobileLauncherLeftEdgeDescription:
    "Vis en firkantet launcher på 44 px midt på venstre kant på mobil med dit eksisterende ikon. Tilsidesætter mobilposition og størrelse, mens indstillingen er slået til.",
  mobileLauncherLeftEdgeBarNotice: "Gælder ikke, når launcher-bjælken er valgt.",
  userMessageColor: "Bruger besked",
  userMessageTextColor: "Bruger besked tekst",
  userMessageBorderColor: "Bruger besked kant",
  inputTextColor: "Inputfelt tekst",
  inputPlaceholderColor: "Inputfelt placeholder",
  inputBackgroundColor: "Inputfelt baggrund",
  inputBorderColor: "Inputfelt kant",
  inputFieldHeight: "Inputfelt højde (px)",
  inputFieldHeightDescription: "Højden på inputfeltet.",
  sendButtonIconColor: "Send-knap ikon",
  headerLogo: "Header logo (upload fil)",
  messageIcon: "Avatar (upload fil)",
  messageIconSize: "Avatar størrelse (px)",
  messageIconSizeDescription: "Størrelsen på avataren.",
  fontSize: "Tekststørrelse (px)",
  fontSizeDescription: "Tekststørrelse i chatten. Standard er 16. Tilladt interval: 10–24.",
  headerTitle: "Header titel",
  headerSubtitle: "Header undertitel",
  formattedTextHint: "Brug Fed eller Link til at formatere dele af teksten.",
  formattedTextBold: "Fed",
  formattedTextLink: "Link",
  formattedTextLinkPrompt: "Indtast link-URL",
  privacyPolicyUrl: "Privatlivspolitik link",
  headerAlignment: "Header justering",
  alignLeft: "Venstrejuster",
  alignCenter: "Centrer",
  alignRight: "Højrejuster",
  siteTitle: "Side titel",
  initialMessage: "Indledende besked",
  buttonColor: "Knapbaggrund",
  discountPriceColor: "Tilbudspris",
  surfaceThemeGroup: "Overflade",
  headerThemeGroup: "Header",
  messagesThemeGroup: "Beskeder",
  inputThemeGroup: "Input",
  productCardThemeGroup: "Produktkort",
  addToCartButtonIcon: "Tilføj-til-kurv knapikon",
  addToCartButtonIconDescription:
    "Upload et brugerdefineret ikon til tilføj-til-kurv-knappen på produktkort. Lad det være tomt for at bruge standard indkøbskurv-ikonet.",
  addToCartDisabledHint: "Aktivér tilføj-til-kurv i admin-indstillinger for at tilpasse ikonet.",
  moreColorSettings: "Flere farveindstillinger",
  popupMessage: "Popup besked",
  publish: "Publicer",
  uploadLogo: "Upload Logo",
  uploadIcon: "Upload Ikon",
  selectChatbot: "Vælg Chatbot",
  editingChatbotId: "Redigerer Chatbot ID",
  textTooLongWarning: "For meget tekst kan se dårligt ud på mindre skærme",
  borderRadius: "Afrunding af chatbot hjørner",
  borderRadiusDescription:
    "Kontrollerer afrunding af chatbot hjørner (0.5 = skarpt, 1.0 = normalt, 2.0 = meget rundt)",
  zIndexButton: "Z-Index - Knap",
  zIndexChatWindow: "Z-Index - Chatvindue",
  customChatButtonImage: "Brugerdefineret Chat Knap Billede (Valgfrit)",
  customChatButtonDescription:
    "Upload et brugerdefineret billede eller GIF for at erstatte standard SVG chat-knappen. Lad det være tomt for at bruge standardknappen. Hele billedet kan klikkes, så beskær gennemsigtige kanter væk.",
  mobileCustomizations: "Mobil Tilpasninger",
  mobileCustomizationsDescription:
    "Valgfrie tilsidesættelser til mobilenheder. Hvis de ikke er angivet, bruges desktop-indstillingerne.",
  mobileChatButtonImage: "Mobil Chat Knap Billede",
  mobileChatButtonDescription:
    "Upload et separat billede til mobilvisning. Lad det være tomt for at bruge desktop-knappen. Hele billedet kan klikkes, så beskær gennemsigtige kanter væk.",
  adaptiveIconColor: "Adaptiv farve for startknap",
  adaptiveIconColorHint:
    "Gælder kun chat/start-knappen. Upload et simpelt ikon for bedst kontrast på lyse og mørke baggrunde.",
  mobileButtonPositionBottom: "Mobil Knap Position - Bund",
  mobileButtonPositionRight: "Mobil Knap Position - Højre",
  buttonSize: "Knap Størrelse (px)",
  buttonSizeDescription:
    "Størrelsen på chat-knappen i pixels, fra 30 til 200. Et eget billede beholder sine proportioner, og dette er dets længste side. Standard: 74",
  chatbotWidth: "Chatbot bredde",
  chatbotHeight: "Chatbot højde",
  chatbotSizeDescription: "Desktop størrelse.",
  openAnimationEnabled: "Åbn chatbot med glideanimation",
  mobileButtonSize: "Mobil Knap Størrelse (px)",
  mobileButtonSizeDescription:
    "Størrelsen på chat-knappen på mobil i pixels, fra 30 til 200. Et eget billede beholder sine proportioner, og dette er dets længste side. Standard: 50",
  launcherSizeClampedNotice: "Chat-knappen vises i {size} px.",
  removeButton: "Fjern",
  resetToDefault: "Nulstil til standard",
  clickSaveToPersist: "Klik Gem for at gemme",
  saveReminder: "Ændringer gemmes kun i databasen når du klikker på Gem-knappen ovenfor",
  showPopupOnMobile: "Vis popup på mobile enheder",
  showPopupOnMobileDescription:
    "Fjern markeringen for at deaktivere popup på mobil (vises stadig på desktop)",
  livePreview: "Live Forhåndsvisning",
  openPreviewInNewTab: "Åbn i ny fane",
  fullscreen: "Fuld skærm",
  exitFullscreen: "Afslut fuld skærm",
  desktop: "Desktop",
  mobile: "Mobil",
  chatbotActive: "Aktiv",
  chatbotDisabled: "Deaktiveret",
  disabledSince: "Deaktiveret siden",
  disableChatbot: "Deaktiver Chatbot",
  disableChatbotConfirmation:
    "Er du sikker på, at du vil deaktivere denne chatbot? Den vil ikke længere være synlig på din hjemmeside.",
  enableChatbot: "Aktiver chatbot",
  enableChatbotConfirmation:
    "Er du sikker på, at du vil aktivere denne chatbot? Den vil igen være synlig på din hjemmeside for besøgende.",
  cancel: "Annuller",
  disable: "Deaktiver",
  enable: "Aktiver",
  developerChatbotVisibilityTitle: "Chatbot på din hjemmeside",
  developerChatbotVisibilitySectionDescription:
    "Slå den offentlige chatbot til eller fra for besøgende. Dette påvirker ikke redigering eller forhåndsvisning under Chatbot.",
  developerChatbotVisibilityChatbotLabel: "Chatbot",
  developerDisableChatbotButton: "Deaktiver chatbot på hjemmesiden",
  developerEnableChatbotButton: "Aktiver chatbot på hjemmesiden",
  developerChatbotVisibilityAcknowledge:
    "Jeg forstår, at dette ændrer den aktive hjemmeside for besøgende.",
  developerChatbotVisibilityNoChatbots:
    "Ingen chatbots tilknyttet denne konto. Chatbot-ID'er indlæses, når du logger ind.",
  developerChatbotVisibilityDisabledNotice:
    "Chatbotten er deaktiveret på den offentlige hjemmeside.",
  developerChatbotVisibilityEnabledNotice:
    "Chatbotten er nu aktiveret på den offentlige hjemmeside.",
  developerChatbotVisibilityStatusActive: "Aktiv på hjemmesiden",
  developerChatbotVisibilityStatusDisabled: "Deaktiveret på hjemmesiden",
  developerChatbotVisibilityLoadError: "Kunne ikke indlæse chatbot-status.",
  developerChatbotVisibilityToggleError: "Kunne ikke opdatere chatbot-status.",
  popupDailyDesktop: "Computer: maksimale visninger pr. dag",
  popupTotalDesktop: "Computer: maksimale visninger i alt",
  popupDailyMobile: "Mobil: maksimale visninger pr. dag",
  popupTotalMobile: "Mobil: maksimale visninger i alt",
  popupEveryNthPage: "Vis på hver N. matchende side",
  popupDismissDays: "Pause efter lukning (dage)",
  popupFrequency: "Visningshyppighed",
  popupUseDefault: "Brug bottens standard",
  popupResetDefaults: "Nulstil til bottens standarder",
  popupFrequencyHelp:
    "Grænser gælder separat for hver besked i denne browser. Dagsgrænser nulstilles ved midnat dansk tid. Matchende sider tælles på tværs af dage. Lukning pauser kun den besked; åbning af chatten pauser alle beskeder resten af dagen. Sæt en visningsgrænse til 0 for at deaktivere det layout.",
  popupMaxDisplays: "Popup Maks Visninger (Desktop og Mobil)",
  popupMaxDisplaysDescription:
    "Maksimalt antal visninger pr. popup i den besøgendes browser, på desktop og mobil. Sæt til 0 for at deaktivere popups. Standard: 2",
  chatbotWindowDimensions: "Chatbot Vindue Dimensioner",
  chatbotWindowDimensionsDescription:
    "Kontroller hvordan chatbot iframe'en er størrelse. Understøtter CSS-værdier som px, vw, vh, calc(), osv.",
  desktopWidth: "Desktop Bredde",
  desktopHeight: "Desktop Højde",
  mobileWidth: "Mobil Bredde",
  mobileHeight: "Mobil Højde",
  enlargedWidth: "Forstørret Bredde",
  enlargedHeight: "Forstørret Højde",
  // Livechat Settings translations
  // Livechat Settings translations
  livechatSettingsTitle: "Livechat Indstillinger",
  agentInformation: "Agent Information",
  agentNameLabel: "Dit agentnavn",
};
